import { render, staticRenderFns } from "./viewQuestionDetail.vue?vue&type=template&id=2d796a10&"
import script from "./viewQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./viewQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewQuestionDetail.vue?vue&type=style&index=0&id=2d796a10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports